import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const AlertsToast = ({ notifications }) => {
	const prevNotificationsRef = useRef([]);

	useEffect(() => {
		const prevNotifications = prevNotificationsRef.current;
		const newNotifications = notifications.filter(
			(notification) => !prevNotifications.includes(notification)
		);
		if (newNotifications.length > 0) {
			newNotifications.map((notification) =>
				handleToast(notification.alert_description)
			);
		}
		prevNotificationsRef.current = notifications;
	}, [notifications]);

	const handleToast = useCallback(
		(message) => {
			toast.info(message, {
				position: 'bottom-right', // You can customize the position as per your requirement
				autoClose: 8000, // Toast will close automatically after 3 seconds
				hideProgressBar: true, // You can choose to hide the progress bar
				closeOnClick: true, // Close the toast when clicked
				pauseOnHover: true, // Pause closing when hovered
				draggable: true, // Allow dragging of the toast
			});
		},
		[notifications]
	);

	return <ToastContainer limit={5} />;
};

AlertsToast.propTypes = {
	handleSnackBarClose: PropTypes.func,
	message: PropTypes.string,
	showAlert: PropTypes.bool,
};
